import lodash from 'lodash'
import queryString from 'query-string'
import md5 from 'md5'

const mixin = {
  md5,
  shuffle: lodash.shuffle,
  assign: lodash.assign,
  parseParams: queryString.parse,
  stringify: queryString.stringify
}

const copy = (target, source, prefix) => {
  for (let k in source) {
    target[prefix + k] = source[k]
  }
}

export default function (Vue) {
  copy(Vue, mixin, '')

  Vue.mixin({
    created () {
      copy(this, mixin, '$')
    }
  })
}



// WEBPACK FOOTER //
// ./src/mixins/index.js